<template>
  <div v-if="config.payment.stripe.enabled" id="stripe-button">
    <stripe-checkout
      ref="checkoutRef"
      mode="subscription"
      :pk="config.payment.stripe.stripePublishableKey"
      :success-url="successURL"
      :cancel-url="cancelURL"
      :customer-email="customerEmail"
      :line-items="lineItems"
    />
   <div @click="submit" class="stripe-button-black">
       <v-progress-circular

               v-if="loading"
               indeterminate
               :width="2"
               :size="20"
               color="gray"
       ></v-progress-circular>
     <button style="margin-left:20px;" v-if="!loading">
        <v-icon left class="credit-card-icon" color="#fff">mdi-credit-card-outline</v-icon>
       Debit or Credit Card</button>
     </div>
  </div>
</template>
<style>

.stripe-button-black {
   text-align: center;
    font-size: 16px;

    padding: 13px 0;
    border-radius: 4px;
    background: #2C2E2F;
    color: #fff;
    margin-bottom: 15px;
}

.credit-card-icon {
  font-size: 27px;
    color: #fff;
    position: absolute;
    margin-left: -34px;
    margin-top: -2px;
    font-weight: 100;
}
</style>
<script>
import config from '../config'
import i18n from '@/i18n';
import { StripeCheckout } from '@vue-stripe/vue-stripe';
export default {
  props: {
    'customer-email': {
            type: String
        },
        'subscription-type': {
            type: String
        },
       hadSubscription: { type: Boolean }
  },
  components: {
    StripeCheckout,
  },
    created(){
      this.submit = this.submit.bind(this);
    },
  computed: {
    lineItems() {
        const subscriptionTypes  = {
                       withTrial: {
                          Monthly: config.payment.stripe.plans.threeDaysTrial_Monthly_SevenNinetyNine,
                          SemiAnnual: config.payment.stripe.plans.threeDaysTrial_SemiAnnual_FiveNinetyNine,
                          Annual: config.payment.stripe.plans.threeDaysTrial_Annual_ThreeNinetyNine
                       },
                       withoutTrial: {
                          Monthly: config.payment.stripe.plans.Monthly_SevenNinetyNine,
                          SemiAnnual: config.payment.stripe.plans.SemiAnnual_FiveNinetyNine,
                          Annual: config.payment.stripe.plans.Annual_ThreeNinetyNine
                       }
               };
        const plan = this.hadSubscription? subscriptionTypes.withoutTrial[this.subscriptionType] : subscriptionTypes.withTrial[this.subscriptionType];
        return [
                {
                  price: plan.planId, // The id of the recurring price you created in your Stripe dashboard
                  quantity: 1,
                }
        ];
    }
  },
  
  data () {
    return {
      config,
      loading: false,
      successURL: config.serverURL + '/' + i18n.locale + '/account',
      cancelURL: config.serverURL + '/' + i18n.locale + '/account'
    };
  },
      
    
  methods: {
      _handleError(){this.loading = false;},
      _handleSuccess(){
          this.loading = false;
          this.$emit('loadpaymentdata');
      },
    submit () {
this.loading =  true;



        const addressBarEstimatedHeight = 100;

        const popupDimensions = {width: 500, height: 600};

        const popupPosition = {top: addressBarEstimatedHeight + window.screenY + ((window.innerHeight - popupDimensions.height) / 2), left: window.screenX + ((window.innerWidth - popupDimensions.width) / 2) };

      // You will be redirected to Stripe's secure checkout page
        var win = window.open(`/stripecheckout.html?customer_email=${this.customerEmail}&stripe_pk=${config.payment.stripe.stripePublishableKey}&line_items=${JSON.stringify(this.lineItems)}`,'targetWindow',
                                   `toolbar=no,
                                    location=no,
                                    status=no,
                                    menubar=no,
                                    scrollbars=yes,
                                    resizable=yes,
                                    top=${popupPosition.top},
                                    left=${popupPosition.left},
                                    width=${popupDimensions.width},
                                    height=${popupDimensions.height}`);

        //TODO: set loader
        window.onmessage =  (e)=> {
            if(e.data.response){
                win.close();
                e.data.response !== 'success'? this._handleError(win) : this._handleSuccess()

            }
        };

        var timer = setInterval(()=> {
            if (win.closed) {
                win.close();
                this._handleError()
                clearInterval(timer);
            }
        }, 500);


      // this.$refs.checkoutRef.redirectToCheckout();
    }
  }
};
</script>
